import { Tooltip } from '@ets/design-system';
import usePublicProfile from '_common/hooks/usePublicProfile';
import { useIntl } from 'react-intl';

type TooltipApprovedWidgetProps = {
  testId: string;
  content: string;
  userId?: UserId;
  children: React.ReactNode;
};

const TooltipApprovedWidgetView = ({
  testId,
  content,
  userId,
  children,
}: TooltipApprovedWidgetProps) => {
  const intl = useIntl();
  const profile = usePublicProfile(userId ?? '');

  return (
    <Tooltip
      testId={testId}
      content={`${intl.formatMessage({ id: content })} ${profile.name}`}
      open={true}
      placement={'right'}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipApprovedWidgetView;
